import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d426caf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-viewer-settings" }
const _hoisted_2 = { class: "has-text-table-cell-title" }
const _hoisted_3 = { class: "has-text-table-cell-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButtonList = _resolveComponent("RadioButtonList")!
  const _component_AutoClipToggleSwitch = _resolveComponent("AutoClipToggleSwitch")!
  const _component_AddonViewProcessingColor = _resolveComponent("AddonViewProcessingColor")!
  const _component_TwoInOneCoverPageToggleSwitch = _resolveComponent("TwoInOneCoverPageToggleSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dl", null, [
      _createElementVNode("dt", _hoisted_2, _toDisplayString(_ctx.$t('mobileImageViewer.viewMode')), 1),
      _createElementVNode("dd", null, [
        _createVNode(_component_RadioButtonList, {
          id: "displayedFrames",
          modelValue: _ctx.viewModeType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewModeType) = $event)),
          items: _ctx.viewModeListLocal,
          onChange: _ctx.changeViewMode
        }, null, 8, ["modelValue", "items", "onChange"])
      ]),
      _createElementVNode("dt", _hoisted_3, _toDisplayString(_ctx.$t('mobileImageViewer.bindingDirection')), 1),
      _createElementVNode("dd", null, [
        _createVNode(_component_RadioButtonList, {
          id: "directionTwoFrame",
          modelValue: _ctx.currentBindingDirection,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentBindingDirection) = $event)),
          items: _ctx.directionList
        }, null, 8, ["modelValue", "items"])
      ])
    ]),
    _hoisted_4,
    _createVNode(_component_AutoClipToggleSwitch),
    (_ctx.hasClippingData)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
      : _createCommentVNode("", true),
    _createVNode(_component_AddonViewProcessingColor),
    _createVNode(_component_TwoInOneCoverPageToggleSwitch)
  ]))
}